module.exports = __webpack_public_path__ + "static/media/sidemenu-collapse-icon.1b60da2f.svg";